initSW();

let installingWorker;

function initSW() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js')
                .then(reg => {
                    console.log('Service Worker registered! Scope');
                    if (window.user !== 0) {
                        initPush();
                    }
                    reg.onupdatefound = () => {
                        installingWorker = reg.installing;
                        console.log('status: ' + installingWorker.state);
                        installingWorker.onstatechange = () => {
                            switch (installingWorker.state) {
                                case 'installed':
                                    if (navigator.serviceWorker.controller) {
                                        console.log('new update available');
                                        window.location.reload()
                                        alert('Aplicación actualizada correctamente');
                                    } else {
                                        console.log('not controller');
                                    }
                                    break;
                            }
                        };
                    };
                })
                .catch(err => {
                    console.log('Service Worker registration failed');
                });
        });
        let refreshing;
        navigator.serviceWorker.addEventListener('controllerchange', function () {
            if (refreshing) return;
            window.location.reload();
            refreshing = true;
        });
    }

    window.addEventListener('load', () => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('loggedin') && urlParams.get('loggedin') === 'true') {
            console.log('User just logged in, notifying Service Worker...');
            
            if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: 'USER_LOGGED_IN' });
            }
    
            urlParams.delete('loggedin');
            const newUrl = window.location.pathname + '?' + urlParams.toString();
            window.location = newUrl
        }
    });
    
    window.addEventListener('userLogout', () => {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'USER_LOGOUT' });
        }
    });
}

function initPush() {
    if (!navigator.serviceWorker.ready) {
        return;
    }

    new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    })
        .then((permissionResult) => {
            if (permissionResult !== 'granted') {
                throw new Error('We weren\'t granted permission to notifications.');
            }
            subscribeUser();
        });
}

function subscribeUser() {
    navigator.serviceWorker.ready
        .then((registration) => {
            const subscribeOptions = {
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(
                    'BCpkbk9hxfWZ0x-DJkex09-UGqf9XWGH_amnuT8NiXowkxj8L8rLbAOoDK1EUe4UC3e_5IGKOuX_od70cKYFdoU'
                )
            };

            return registration.pushManager.subscribe(subscribeOptions);
        })
        .then((pushSubscription) => {
            storePushSubscription(pushSubscription);
        });
}

function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function storePushSubscription(pushSubscription) {
    const token = document.querySelector('meta[name=csrf-token]').getAttribute('content');

    fetch('/push', {
        method: 'POST',
        body: JSON.stringify(pushSubscription),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': token
        }
    })
        .then((res) => {
            return res.json();
        })
        .catch((err) => {
            console.log(err)
        });
}